export default __webpack_public_path__ + "60ff378ed6b0d30d8e213f6b3f629e2c.png";